import { IconProps } from './types';

export const CharityIcon = ({ title = 'Charity Icon', ...props }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" fill="none" viewBox="0 0 37 37" {...props}>
        <title>{title}</title>
        <path
            fill="#0A2F73"
            d="M10.791 30.872V16.958h2.467q.27 0 .54.058.27.057.539.135l10.676 3.97q.54.193.867.693.328.501.328 1.04 0 .81-.56 1.311a1.88 1.88 0 0 1-1.29.501H20.31q-.193 0-.29-.019a1 1 0 0 1-.25-.096l-2.466-.964-.502 1.503 2.968 1.04a.8.8 0 0 0 .232.059 2 2 0 0 0 .27.019h10.56q1.233 0 2.158.887.925.886.925 2.196l-12.295 4.625zm-9.25 3.044V16.958h6.167v16.958zm23.125-13.875-6.398-6.243a12 12 0 0 1-2.023-2.563 5.93 5.93 0 0 1-.829-3.064q0-2.12 1.484-3.604 1.484-1.485 3.604-1.484 1.233 0 2.312.52 1.08.52 1.85 1.407a5.7 5.7 0 0 1 1.85-1.407q1.08-.52 2.313-.52 2.12 0 3.603 1.484 1.485 1.484 1.484 3.604 0 1.656-.81 3.064a11.6 11.6 0 0 1-2.004 2.563z"
        ></path>
        <path
            fill="#FB0"
            d="m24.666 20.041-6.398-6.243a12 12 0 0 1-2.023-2.563 5.93 5.93 0 0 1-.829-3.064q0-2.12 1.484-3.604 1.484-1.485 3.604-1.484 1.233 0 2.312.52 1.08.52 1.85 1.407a5.7 5.7 0 0 1 1.85-1.407q1.08-.52 2.313-.52 2.12 0 3.603 1.484t1.484 3.604q0 1.656-.81 3.064a11.6 11.6 0 0 1-2.003 2.563z"
        ></path>
    </svg>
);
